import { gql } from "@apollo/client";

export const ImageFragment = gql`
  fragment ImageFragment on UploadFile {
    attributes {
      url
      alternativeText
      mime
    }
  }
`;
